<template>
    <div class="notifications-info">
        <a class="nav-link" href="/notifications">
            <img src="/img/svg/bel.svg" alt="" class="bell">
            <span class="badge badge-pill" v-if="GET_NOTIFICATIONS_COUNT">{{ GET_NOTIFICATIONS_COUNT > 9 ? '+9' : GET_NOTIFICATIONS_COUNT }}</span>
        </a>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: mapGetters(['GET_NOTIFICATIONS_COUNT'])
    }
</script>
